import { render, staticRenderFns } from "./smsConfiguration.vue?vue&type=template&id=c643bf60&scoped=true"
import script from "./smsConfiguration.vue?vue&type=script&lang=js"
export * from "./smsConfiguration.vue?vue&type=script&lang=js"
import style0 from "./smsConfiguration.vue?vue&type=style&index=0&id=c643bf60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c643bf60",
  null
  
)

export default component.exports